/**
 * The consent sentence shown on the success screen, and the version stamped
 * alongside it when a guest opts in.
 *
 * This literal is pinned by `tests/copy/outcomeConsent.test.ts` against the
 * backend's `constants/guestOutcomeConsent.ts`, which is what actually gets
 * stored. If the two drift, the audit record says something the guest never saw.
 *
 * Changing the wording means adding a NEW version on both sides — never editing
 * a published one in place.
 */
export const OUTCOME_CONSENT_VERSION = 'v1';

export const OUTCOME_CONSENT_COPY =
  "We'll send one message when this moment is finished. Nothing else.";
